// Fix lazyload crash
import '@/common/components/molecules/ButtonLoading/ButtonLoading.scss';
import '@/common/components/blocks/Modal/Common/ConfirmationMessage/ConfirmationMessage.scss';
import '@/common/components/blocks/Price/Price.scss';
import '@/common/components/blocks/Tag/Tag.scss';
import '@/common/components/blocks/Modal/Common/AddressDetail/AddressDetail.scss';
import '@/common/components/molecules/Range/Range.scss';
import '@/common/components/molecules/SortBy/SortBy.scss';
import '@/common/components/organisms/SliderMedia/SliderMedia.scss';
import '@/common/components/organisms/SliderMedia/CustomPaging/CustomPaging.scss';
import '@/common/components/organisms/SliderMedia/CustomArrow/CustomArrow.scss';
import '@/common/components/organisms/SliderMedia/ModalItem/ModalItem.scss';
import '@/common/components/organisms/SliderMedia/Item/Item.scss';

import React from 'react';

const withBuild = (Children) => (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Children {...props} />
);

export default withBuild;

